import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReviewSpinner from '../ReviewSpinner';
import { fetchUrl } from 'ducks/reviewDocuments';

/**
 * Renders an image.
 *
 * @param document the review document
 * @return {JSX.Element}
 */
const ImageViewer = ({ document }) => {
  const [url, setUrl] = useState();

  useEffect(() => {
    setUrl(null);
    fetchUrl(document).then(url => setUrl(url));
  }, [document.document_url]);

  return (
    <div className="review-image-viewer">
      {!url && <ReviewSpinner/>}
      {url && <img src={url} className="review-documents-image" alt={document.name}/>}
    </div>
  );
};

ImageViewer.propTypes = {
  document: PropTypes.shape({
    name: PropTypes.string,
    document_url: PropTypes.string,
  })
};

export default ImageViewer;
